var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "10.5 7.5 9 15.999"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m10.784 21.853 6.379-6.354-6.38-6.353a.963.963 0 0 1 0-1.364.97.97 0 0 1 1.37 0l7.063 7.036a.96.96 0 0 1 0 1.363l-7.063 7.036a.97.97 0 0 1-1.37 0 .963.963 0 0 1 0-1.364"
})));
export default SvgChevronRight;